<template>
    <div>
        
    </div>
</template>
<script>
export default {
    data() {
        return {
            firsDate:''
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Login/teText.vue